export const IntentStatuses = {
  PendingAnalysis: 'Pending Analysis',
  Analyzed: 'Analyzed',
  ReadyForBacklog: 'Ready for Backlog',
} as const

export const intentStatusFilterOptions = Object.values(IntentStatuses).map((status) => ({
  value: status,
  label: status
}))

export type IntentStatus = typeof IntentStatuses[keyof typeof IntentStatuses]

export interface Intent {
  id: string
  number: number
  name: string
  epic: string | null
  feature: string | null
  status: IntentStatus
  createdAt: string
}

export interface IntentDetail {
  id: string
  number: number
  name: string
  epic: string | null
  feature: string | null
  description: string | null
  status: IntentStatus
  createdAt: string
}

export interface IntentFilters {
  search?: string
  epic?: string
  feature?: string
  statuses?: string[]
  sortBy?: IntentSortColumn
  sortDirection?: 'asc' | 'desc'
}

export type IntentSortColumn = 'number' | 'name' | 'epic' | 'feature' | 'status' | 'created'

export const INTENT_DEFAULT_SORT_DIRECTIONS: Record<IntentSortColumn, 'asc' | 'desc'> = {
  number: 'desc',
  name: 'asc',
  epic: 'asc',
  feature: 'asc',
  status: 'asc',
  created: 'desc',
}

export interface CreateIntentRequest {
  name: string
  epic?: string
  feature: string
  description?: string
}

export interface UpdateIntentRequest {
  name: string
  epic?: string | null
  feature: string
  description?: string | null
}
